let html2canvasImport
if (import.meta.client) {
  html2canvasImport = import('@stefankost/html2canvas')
}

export default async function takeScreenshot() {
  const { default: html2canvas } = await html2canvasImport
  if (!html2canvas) {
    return null
  }

  const root = document.body

  // we need the scale to manually resize the canvas as well as passing it to html2canvas
  const scale = window.devicePixelRatio

  const canvas = document.createElement("canvas")
  canvas.width = root.offsetWidth * scale
  canvas.height = root.offsetHeight * scale

  await html2canvas(root, { canvas, scale, scrollY: 0, scrollX: 0 })

  return new Promise((resolve, reject) => {
    try {
      canvas.toBlob(resolve, 'image/jpeg')
    } catch (err) {
      reject(err)
    }
  })
}
